export const getDataKeyName = (dataKey) => {
  if (!Array.isArray(dataKey)) {
    dataKey = [dataKey];
  }
  return dataKey.map((el) => {
    switch (el) {
      case "solarGenerated":
        return "Solar Generated";
      case "gridConsumed":
        return "Grid Consumed";
      case "co2Saved":
        return "CO₂e Avoided";
      case "co2Produced":
        return "CO₂e Emitted";
      case "solarConsumed":
        return "Self Consumed";
      case "consumedEnergy":
        return "Energy Consumed";
      case "generatedEnergy":
        return "Energy Generated";
      case "netConsumed":
        return "Net Consumed";
      case "solarReturned":
        return "Solar Exported";
      case "solarFeedIn":
        return "Solar Exported";
      case "voltage":
        return "Voltage";
      case "current":
        return "Current";
      case "realEnergyJoules":
        return "Joules";
      case "realEnergy":
        return "Energy";
      case "realPower":
        return "Power";
      case "reactiveEnergyJoules":
        return "Reactive Energy";
      case "reactiveEnergy":
        return "Reactive Energy";
      case "reactivePower":
        return "Reactive Power";
      case "apparentPower":
        return "Apparent Power";
      case "powerFactor":
        return "Power Factor";
      case "costs":
        return "Costs";
      case "gridConsumedValue":
        return "Costs";
      case "savings":
        return "Savings";
      case "solarGeneratedValue":
        return "Savings";
      case "minNetConsumedAvgPerPerson":
        return "Lowest Consumption";
      case "maxNetConsumedAvgPerPerson":
        return "Highest Consumption";
      default:
        return null;
    }
  });
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/utilities/UnitsAndKeys/getDataKeyName.js